<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :search="search" v-if="!addUser" :headers="headers" :items="eventos" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">EVENTOS</v-toolbar-title>
          <v-spacer></v-spacer>
          
          <!-- Seletor de Empresa -->
          <v-autocomplete
            v-if="user.tipo == 'ADMIN'"
            v-model="empresaSelecionada"
            :items="empresas"
            item-text="nome"
            item-value="id"
            label="Selecione uma Empresa"
            outlined
            dense
            hide-details
            class="mr-4"
            style="max-width: 300px;"
            @change="carregaDados"
          ></v-autocomplete>
          
          <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <!-- <form ref="myform" action="confirmarPagamento" method="POST"></form> -->
          <v-btn text v-if="user.tipo == 'ADMIN'" @click="addNewEvento" tile color="#4A148C">
            <v-icon left dark>add_circle</v-icon> Adicionar novo
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon @click="editItem(item)">edit</v-icon>
        <v-icon medium @click="deleteItem(item)" v-if="companyobj.agenda || companyobj.vigilante">delete</v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="#7B1FA2" @click="carregaDados">Recarregar</v-btn>
      </template>
    </v-data-table>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else style="border-radius: 10px;">
      <template>
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#7B1FA2"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.descricao" outlined label="Descrição" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.vagas" outlined label="Vagas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.reserva" outlined label="Reservas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.inicio" placeholder="01/01/2020 00:00:00" v-mask="'##/##/#### ##:##:##'" outlined label="Início" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.fim" placeholder="01/01/2020 00:00:00" v-mask="'##/##/#### ##:##:##'" outlined label="Fim" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-if="!companyobj.vigilante">
                <v-text-field v-model="editedItem.urlLive" outlined label="URL da Live" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-select v-model="editedItem.exigePagamento" outlined label="Exige Pagamento" color="#7B1FA2" :items="exigePagamento" hide-details item-text="text" item-value="value"></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-select v-model="editedItem.permiteUpgrade" outlined label="Permite Upgrade" color="#7B1FA2" :items="exigePagamento" hide-details item-text="text" item-value="value"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field v-model="editedItem.vendaMinima" outlined label="Venda Mínima" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field v-model="editedItem.vendaMaxima" outlined label="Venda Máxima" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.subtitulo" outlined label="Subtítulo" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select v-model="editedItem.tipoDocumento" outlined label="Tipo de Documento" color="#7B1FA2" :items="['AMBOS', 'CPF', 'CNPJ']"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select v-model="editedItem.documentoPadrao" outlined label="Documento Padrão" color="#7B1FA2" :items="['CPF', 'CNPJ']"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field v-model="editedItem.vagasMasculinas" outlined label="Vagas Masculinas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field v-model="editedItem.vagasFemininas" outlined label="Vagas Femininas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlCapa" outlined label="URL da Capa" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlMapa" outlined label="URL do Mapa" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlImgObs" outlined label="URL Imagem Observações" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlImgConfirmacaoPagamento" outlined label="URL Imagem Confirmação Pagamento" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlCertificado" outlined label="URL do Certificado" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlTabelaHorarios" outlined label="URL Tabela de Horários" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.local" outlined label="Local" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.localizacao" outlined label="Localização (URL do Maps)" color="#7B1FA2"></v-text-field>
              </v-col>
              
              <v-col cols="12" sm="12">
                <v-divider></v-divider>
                <h3 class="mt-4 mb-2">Configurações de Pagamento</h3>
              </v-col>
              
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.valor" outlined label="Valor" color="#7B1FA2" prefix="R$"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.valorPix" outlined label="Valor Pix" color="#7B1FA2" prefix="R$"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.valorCartao" outlined label="Valor Cartão" color="#7B1FA2" prefix="R$"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.desconto" outlined label="Desconto" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.lote" outlined label="Lote" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.quantidadeParcelas" outlined label="Quantidade de Parcelas" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              
              <v-col cols="12" sm="12">
                <v-divider></v-divider>
                <h3 class="mt-4 mb-2">Acréscimos de Pagamento</h3>
              </v-col>
              
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao1" outlined label="Acréscimo Cartão 1x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao2" outlined label="Acréscimo Cartão 2x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao3" outlined label="Acréscimo Cartão 3x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao4" outlined label="Acréscimo Cartão 4x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao5" outlined label="Acréscimo Cartão 5x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao6" outlined label="Acréscimo Cartão 6x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao7" outlined label="Acréscimo Cartão 7x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao8" outlined label="Acréscimo Cartão 8x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao9" outlined label="Acréscimo Cartão 9x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao10" outlined label="Acréscimo Cartão 10x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao11" outlined label="Acréscimo Cartão 11x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao12" outlined label="Acréscimo Cartão 12x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoBoleto" outlined label="Acréscimo Boleto" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoPix" outlined label="Acréscimo Pix" color="#7B1FA2"></v-text-field>
              </v-col>
              
              <v-col cols="12" sm="12" v-if="!companyobj.vigilante && user.tipo == 'ADMIN'">
                <v-divider></v-divider>
                <h3 class="mt-4 mb-2">Configurações de Cabeçalho</h3>
              </v-col>
              
              <v-col cols="12" sm="12" md="12" v-if="!companyobj.vigilante && user.tipo == 'ADMIN'">
                <v-btn color="#4A148C" class="mb-4" @click="abrirEditorCabecalho">
                  <v-icon left>edit</v-icon>
                  Editar Colunas do Cabeçalho
                </v-btn>
                
                <v-card v-if="mostrarEditorCabecalho" outlined class="pa-4 mb-4">
                  <v-card-title>Editor de Cabeçalho</v-card-title>
                  <v-card-text>
                    <v-row v-for="(coluna, index) in editedItem.cabecalho" :key="index">
                      <v-col cols="12" sm="5" md="5">
                        <v-text-field v-model="coluna.text" outlined label="Título da Coluna" color="#7B1FA2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5" md="5">
                        <v-text-field v-model="coluna.value" outlined label="Campo de Referência" color="#7B1FA2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-btn icon color="red" @click="removerColuna(index)">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-btn color="#7B1FA2" class="mt-4" dark @click="adicionarColuna">
                      <v-icon left>add</v-icon>
                      Adicionar Coluna
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <v-col cols="12" sm="12" md="12" v-if="companyobj.vigilante">
                <v-select v-model="editedItem.qualificacoes" outlined label="Qualificações Permitidas" color="#7B1FA2" :items="qualificacoes" hide-details item-text="text" item-value="value" multiple></v-select>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlApoio" prefix="R$" outlined label="Diária Apoio" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlBasico" prefix="R$" outlined label="Diária Básico" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlGrandesEventos" prefix="R$" outlined label="Diária Grandes Eventos" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrInicio" outlined label="Hora Início" v-mask="'##:##'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrApresentacao" outlined label="Hora Apresentação" v-mask="'##:##'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrFim" outlined label="Hota Término" v-mask="'##:##'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.endereco" outlined label="Endereço/Localização" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                  <p>Traje</p>
                  <v-radio-group
                    v-model="editedItem.traje"
                    mandatory
                  >
                    <v-radio
                      label="SOCIAL"
                      value="SOCIAL"
                    ></v-radio>
                    <v-radio
                      label="OPERACIONAL"
                      value="OPERACIONAL"
                    ></v-radio>
                  </v-radio-group>
              </v-col>  
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                  <p>Incluso Alimentação</p>
                  <v-radio-group
                    v-model="editedItem.alimentacao"
                    mandatory
                  >
                    <v-radio
                      label="SIM"
                      value="SIM"
                    ></v-radio>
                    <v-radio
                      label="NÃO"
                      value="NÃO"
                    ></v-radio>
                  </v-radio-group>
              </v-col>             
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="save">Salvar</v-btn>
          <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </template>
    </v-card>

    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      limitado: true,
      faixas: [],
      search: '',
      addUser: false,
      mostrarEditorCabecalho: false,
      exigePagamento: [
        { text: 'SIM', value: true, },
        { text: 'NÃO', value: false, },
      ],
      headers: [
        { text: 'Nome', align: 'start', value: 'nome', },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Vagas', align: 'center', value: 'vagas' },
        { text: 'Reservas', align: 'center', value: 'reserva' },
        { text: 'Data Início', value: 'inicio' },
        { text: 'Data Fim', value: 'fim' },
        { text: 'Ações', value: 'action', align: 'center', sortable: false },
      ],
      qualificacoes: ['APOIO', 'VIGILANTE BÁSICO', 'VIGILANTE DE GRANDES EVENTOS'],
      eventos: [],
      editedIndex: -1,
      editedItem: {
        nome: '',
        descricao: '',
        vagas: '',
        reserva: '',
        inicio: '',
        fim: '',
        empresaId: '',
        urlLive: '',
        qualificacoes: [],
        vlApoio: '',
        vlBasico: '',
        vlGrandesEventos: '',
        hrInicio: '',
        hrApresentacao: '',
        hrFim: '',
        endereco: '',
        traje: '',
        alimentacao: '',
        exigePagamento: false,
        permiteUpgrade: false,
        vendaMinima: 1,
        vendaMaxima: 50,
        tipoDocumento: 'AMBOS',
        documentoPadrao: 'CPF',
        urlCapa: '',
        urlMapa: '',
        urlImgObs: '',
        urlImgConfirmacaoPagamento: '',
        vagasMasculinas: 0,
        vagasFemininas: 0,
        urlCertificado: '',
        cabecalho: [],
        quantidadeInscricoes: 0,
        local: '',
        localizacao: '',
        setores: [],
        subtitulo: '',
        acrescimoCartao1: '0,00',
        acrescimoCartao2: '0,00',
        acrescimoCartao3: '0,00',
        acrescimoCartao4: '0,00',
        acrescimoCartao5: '0,00',
        acrescimoCartao6: '0,00',
        acrescimoCartao7: '0,00',
        acrescimoCartao8: '0,00',
        acrescimoCartao9: '0,00',
        acrescimoCartao10: '0,00',
        acrescimoCartao11: '0,00',
        acrescimoCartao12: '0,00',
        acrescimoBoleto: '0,00',
        acrescimoPix: '0,00',
        lote: 1,
        valor: '',
        valorPix: '',
        valorCartao: '',
        desconto: '',
        quantidadeParcelas: 1,
        usaCupomDesconto: false,
        usaCartaoConsumo: false,
        usaLinkDesconto: false,
        exibePorcentagem: false,
        permiteSenhaExtra: false,
        valorSenhaExtra: '',
        parametroContagem: {
          tipo: 'numero',
          parametro: 'qtdSenhasExtra'
        },
        qtdClicks: 0,
        sebraeCodigoEvento: '',
        turmas: [],
        planos: [],
        ordenacao: 0,
        urlTabelaHorarios: '',
        exigeUniforme: false
      },
      defaultItem: {
        nome: '',
        descricao: '',
        vagas: '',
        reserva: '',
        inicio: '',
        fim: '',
        empresaId: '',
        urlLive: '',  
        qualificacoes: [],
        vlApoio: '',
        vlBasico: '',
        vlGrandesEventos: '',
        hrInicio: '',
        hrApresentacao: '',
        hrFim: '',
        endereco: '',
        traje: '',
        alimentacao: '',
        exigePagamento: false,
        permiteUpgrade: false,
        vendaMinima: 1,
        vendaMaxima: 50,
        tipoDocumento: 'AMBOS',
        documentoPadrao: 'CPF',
        urlCapa: '',
        urlMapa: '',
        urlImgObs: '',
        urlImgConfirmacaoPagamento: '',
        vagasMasculinas: 0,
        vagasFemininas: 0,
        urlCertificado: '',
        cabecalho: [],
        quantidadeInscricoes: 0,
        local: '',
        localizacao: '',
        setores: [],
        subtitulo: '',
        acrescimoCartao1: '0,00',
        acrescimoCartao2: '0,00',
        acrescimoCartao3: '0,00',
        acrescimoCartao4: '0,00',
        acrescimoCartao5: '0,00',
        acrescimoCartao6: '0,00',
        acrescimoCartao7: '0,00',
        acrescimoCartao8: '0,00',
        acrescimoCartao9: '0,00',
        acrescimoCartao10: '0,00',
        acrescimoCartao11: '0,00',
        acrescimoCartao12: '0,00',
        acrescimoBoleto: '0,00',
        acrescimoPix: '0,00',
        lote: 1,
        valor: '',
        valorPix: '',
        valorCartao: '',
        desconto: '',
        quantidadeParcelas: 1,
        usaCupomDesconto: false,
        usaCartaoConsumo: false,
        usaLinkDesconto: false,
        exibePorcentagem: false,
        permiteSenhaExtra: false,
        valorSenhaExtra: '',
        parametroContagem: {
          tipo: 'numero',
          parametro: 'qtdSenhasExtra'
        },
        qtdClicks: 0,
        sebraeCodigoEvento: '',
        turmas: [],
        planos: [],
        ordenacao: 0,
        urlTabelaHorarios: '',
        exigeUniforme: false
      },
      empresas: [],
      empresaSelecionada: null,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVO EVENTO ' : 'EDITAR EVENTO'
      }
    }),

    created() {
      if (this.user.tipo === 'ADMIN') {
        this.carregaEmpresas()
      }
    },

    mounted() {
      this.carregaDados()
    },

    methods: {
      async addNewEvento() {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.addUser = true
        await this.verificaDisponibilidade()
      },

      async carregaEmpresas() {
        this.isLoading = true
        try {
          const res = await axios.get(`${baseApiUrl}Empresas?access_token=${sessionStorage.getItem('accToken')}`)
          if (res.data && res.data.length > 0) {
            this.empresas = res.data
          }
          this.isLoading = false
        } catch (error) {
          // console.error("Erro ao carregar empresas:", error)
          this.isLoading = false
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar empresas", "ERRO")
        }
      },

      async carregaDados() {
        this.isLoading = true
        
        // URL base para a consulta
        let url
        
        // Filtra por empresa ou traz todos os eventos dependendo do tipo de usuário
        if (this.user.tipo === 'ADMIN') {
          if (this.empresaSelecionada) {
            url = `${baseApiUrl}eventos?filter={"where":{"empresaId":"${this.empresaSelecionada}"}, "order":"inicio DESC"}&access_token=${sessionStorage.getItem('accToken')}`
          } else {
            url = `${baseApiUrl}eventos?access_token=${sessionStorage.getItem('accToken')}`
          }
        } else {
          url = `${baseApiUrl}eventos?filter={"where":{"empresaId":"${this.companyobj.id}"}, "order":"inicio DESC"}&access_token=${sessionStorage.getItem('accToken')}`
        }
        
        await axios.get(url)
        .then(res => {
          if (res.data != '') {
            this.eventos = res.data
            this.isLoading = false
          } else {
            this.eventos = []
            this.isLoading = false
          }
        })
        .catch(() => {
          this.isLoading = false
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar eventos", "ERRO")
        })
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      editItem(item) {
        this.editedIndex = this.eventos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.addUser = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o Evento: ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}Eventos/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          })
        }
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        this.isLoading = true
        if (this.editedIndex != -1) {
          this.editedItem.vagas = parseInt(this.editedItem.vagas)
          this.editedItem.reserva = parseInt(this.editedItem.reserva)
          this.editedItem.inicio = moment(this.formatDatePadrao(this.editedItem.inicio)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z');
          this.editedItem.fim = moment(this.formatDatePadrao(this.editedItem.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z');
          await axios.patch(`${baseApiUrl}Eventos/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
          .then(res => {
            if (res.data != null) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaDados()
            }
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
        } else {
          this.editedItem.empresaId = this.companyobj.id
          this.editedItem.vagas = parseInt(this.editedItem.vagas)
          this.editedItem.reserva = parseInt(this.editedItem.reserva)
          this.editedItem.inicio = moment(this.formatDatePadrao(this.editedItem.inicio)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z');
          this.editedItem.fim = moment(this.formatDatePadrao(this.editedItem.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z');
          await axios.post(`${baseApiUrl}Eventos/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(res => {
              this.id_evento = res.data.id
              if (res.data != null) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#0288D1", "Evento cadastrado com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
              }
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar evento, tente novamente", "ERRO")
            })
        }
        this.close()
      },

      async verificaDisponibilidade() {
        // ... existing code ...
      },

      abrirEditorCabecalho() {
        this.mostrarEditorCabecalho = !this.mostrarEditorCabecalho;
        
        // Se não houver cabeçalho definido, criar um padrão
        if (!this.editedItem.cabecalho || this.editedItem.cabecalho.length === 0) {
          this.editedItem.cabecalho = [
            { text: "Código", value: "cod_incricao" },
            { text: "Nome", value: "nome" },
            { text: "CPF", value: "cpf" },
            { text: "E-mail", value: "email" },
            { text: "Telefone", value: "telefone" },
            { text: "Valor", value: "valorPago" },
            { text: "Status", value: "statusPagamento" },
            { text: "Realizada em", value: "dataHora" },
            { text: "Checkin", value: "checkin" },
            { text: "Ações", value: "action" }
          ];
        }
      },

      adicionarColuna() {
        if (!this.editedItem.cabecalho) {
          this.editedItem.cabecalho = [];
        }
        this.editedItem.cabecalho.push({ text: '', value: '' });
      },

      removerColuna(index) {
        this.editedItem.cabecalho.splice(index, 1);
      }
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>